module.exports = __webpack_public_path__ + "img/recognition_img.7fd8c0c7.png";